import React, { useContext, useEffect, useState } from 'react'
import { ChartComponent, ChartDivisi, HeaderMobile, HeaderWeb, SidebarComponent } from '../../components'
import { Card, Col, Container, OverlayTrigger, Row, Spinner, Tooltip } from 'react-bootstrap'
import { AuthContext, ThemeContext } from '../../auth';
import { useMediaQuery } from 'react-responsive';
import axios from '../../api/axios';
import { FaDoorOpen } from 'react-icons/fa';
import { MdLibraryBooks, MdWorkHistory } from 'react-icons/md';
import { IoCalendar, IoTime } from 'react-icons/io5';
import Swal from 'sweetalert2';
import RingLoader from 'react-spinners/RingLoader';
import { useNavigate } from 'react-router-dom';
import { ModalShcedule } from '../../components/Modal';


function Dashboard() {
    const { theme } = useContext(ThemeContext);
    const isMobile = useMediaQuery({ maxWidth: 1024 });
    const { userInfo, showSidebar, tokens } = useContext(AuthContext);
    const [listMeeting, setListMeeting] = useState([]);
    const [meetingIncoming, setMeetingIncoming] = useState([]);
    const [meetingToday, setMeetingToday] = useState([]);
    const [historyMeeting, setHistoryMeeting] = useState([]);
    const [listRuangan, setListRuangan] = useState([]);
    const [loading, setLoading] = useState(true);
    const tokenUser = tokens?.token;
    const navigate = useNavigate();

    const retrieveMeeting = (showLoading = true) => {
        if (showLoading) setLoading(true);
        const startTime = Date.now(); // Track start time

        axios
            .get(`/manage/requests/`, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },
            })
            .then((res) => {
                const filterData = res.data.filter((item) => item.status === 'processing');
                setListMeeting(filterData);

                const onGoingMeeting = res.data.filter(
                    (item) => item.status === 'approved' && item.finished === false
                );
                setMeetingIncoming(onGoingMeeting);

                const today = new Date();
                const filteredTodayMeetings = onGoingMeeting.filter((item) => {
                    const meetingStart = new Date(item.waktu_mulai);

                    return (
                        meetingStart.getFullYear() === today.getFullYear() &&
                        meetingStart.getMonth() === today.getMonth() &&
                        meetingStart.getDate() === today.getDate()
                    );
                });

                setMeetingToday(filteredTodayMeetings);

                const currentDate = new Date();
                const currentMonth = currentDate.getMonth();
                const currentYear = currentDate.getFullYear();

                const currentMonthMeetings = res.data.filter((item) => {
                    const isApprovedAndFinished = item.status === 'approved' && item.finished === true;

                    if (item.waktu_selesai && isApprovedAndFinished) {
                        const endDate = new Date(item.waktu_selesai);
                        return endDate.getUTCMonth() === currentMonth && endDate.getUTCFullYear() === currentYear;
                    }
                    return false;
                });

                setHistoryMeeting(currentMonthMeetings);

                // Ensure loading lasts at least 2 seconds
                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);
                setTimeout(() => setLoading(false), delay);
            })
            .catch((err) => {
                const elapsedTime = Date.now() - startTime;
                const delay = Math.max(2000 - elapsedTime, 0);

                setTimeout(() => {
                    setLoading(false);
                    console.error(err);
                    Swal.fire({
                        icon: 'error',
                        title: 'Oops...',
                        text: 'Gagal memuat data pada server!',
                    });
                }, delay);
            });
    };

    const retrieveRuangan = () => {
        setLoading(true);
        axios.get(`/manage/ruangan/`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Token ` + tokenUser,
                },

            })
            .then(res => {

                setListRuangan(res.data);
                setLoading(false);
            }).catch(err => {
                console.error(err);
                setLoading(false);
            })
    }

    useEffect(() => {
        if (tokenUser !== undefined) retrieveMeeting(true);
        if (tokenUser !== undefined) retrieveRuangan(true);
    }, [tokenUser]);

    const intervalMinutes = 2;

    useEffect(() => {
        const intervalId = setInterval(() => {
            if (tokenUser !== undefined) {
                retrieveMeeting(false);
            }
        }, intervalMinutes * 60000);

        return () => clearInterval(intervalId);
    }, [tokenUser]);

    const truncateText = (text, maxLength) => {
        return text.length > maxLength ? `${text.slice(0, maxLength)}...` : text;
    };

    const renderTooltip = (props, fullName) => (
        <Tooltip id="button-tooltip" {...props}>
            {fullName}
        </Tooltip>
    );

    function formatDate(dateStr) {
        const [year, month, day] = dateStr.split('-');
        return `${day}-${month}-${year}`;
    }

    const [showCalendar, setShowCalendar] = useState(false);

    const handleShowShcedule = () => {
        setShowCalendar(true)
    };

    const dataOngoingMeeting = meetingIncoming.map((data, index) => {


        if (index > 2) {
            return null;
        }

        return (
            <div key={index} className='mt-4'>
                <Row>
                    <Col xs={8} className='text-start'>
                        <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                            <div
                                className='my-auto'
                                style={{
                                    width: '40px',
                                    height: '40px',
                                    borderRadius: '50%',
                                    border: '2px solid #2f4b7c',
                                    backgroundColor: 'transparent',
                                    borderRadius: '50%',
                                    border: theme === 'light' ? '2px solid #D2DC02' : '2px solid #10B1AA',
                                    backgroundColor: 'transparent',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    marginRight: '8px',
                                    fontFamily: 'Poppins-Regular',
                                    fontSize: '16px',
                                    color: theme === 'light' ? '#D2DC02' : '#10B1AA',
                                }}
                            >
                                {index + 1}
                            </div>
                            <div className='pt-1 ps-4'>
                                <p
                                    style={{
                                        fontFamily: 'Poppins-Regular',
                                        fontSize: '18px',
                                        marginBottom: '0px',
                                        color: theme === 'light' ? '#FFFFFF' : '#222'
                                    }}
                                >
                                    <OverlayTrigger
                                        placement="top"
                                        delay={{ show: 250, hide: 400 }}
                                        overlay={renderTooltip({}, data?.nama_meeting)}
                                    >
                                        <span>
                                            {truncateText(data?.nama_meeting || '', 25)}
                                        </span>
                                    </OverlayTrigger>
                                </p>
                                <p
                                    style={{
                                        fontFamily: 'Poppins-Light',
                                        fontSize: '15px',
                                        color: '#707070',
                                        marginTop: '0px',
                                    }}
                                >
                                    {formatDate(data?.waktu_mulai.split('T')[0])}
                                </p>
                            </div>
                        </div>
                    </Col>
                    <Col xs={4} className='text-end'>
                        <p
                            className='pt-3'
                            style={{
                                fontFamily: 'Poppins-Light',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'flex-end',
                                color: theme === 'light' ? '#FFFFFF' : '#222',
                                margin: 0,
                            }}
                        >
                            <IoTime size={18} color={theme === 'light' ? '#D2DC02' : '#10B1AA'} style={{ marginRight: '8px' }} />
                            {data?.waktu_mulai.split('T')[1].split('Z')[0].slice(0, 5)}
                        </p>
                    </Col>
                </Row>

                {index === 2 && (
                    <div className='text-center mt-5'>
                        <button
                            onClick={handleShowShcedule}
                            style={{
                                background: 'none',
                                border: 'none',
                                color: theme === 'light' ? '#D2DC02' : '#10B1AA',
                                fontFamily: 'Poppins-Regular',
                                cursor: 'pointer',
                                textDecoration: 'underline',
                            }}
                        >
                            lihat selengkapnya
                        </button>
                    </div>
                )}
            </div>
        );
    });

    return (
        <div style={{
            overflowX: 'hidden',
            maxWidth: '100vw',
            backgroundColor: theme === 'light' ? '#121212' : '#FFFFFF',
            transition: '0.8s'
        }} >
            <SidebarComponent />
            {loading && (
                <div id={theme === 'light' ? 'loading-overlay-dark' : 'loading-overlay-light'}>
                    <RingLoader
                        size={80}
                        color={theme === 'light' ? '#D2DC02' : '#10B1AA'}
                    />
                </div>
            )}
            {!loading && (
                <div id={theme === 'light' ? 'containerAppDark' : 'containerAppLight'}
                    style={{
                        width: isMobile ? '100%' : `calc(100% - ${showSidebar ? '80px' : '210px'})`,
                        marginLeft: isMobile ? '0px' : showSidebar ? '80px' : '210px',
                        transition: '0.8s'
                    }}
                >
                    <Row className='mb-2 pt-2 ms-1'>
                        <Col xs={12} md={12} lg={12} className='mt-3'>
                            <Row >
                                <Col xs={8} lg={8} className='text-start'>
                                    <h3 style={{ fontFamily: 'Poppins-Medium', fontSize: isMobile ? '28px' : '38px', color: theme === 'light' ? '#FFFFFF' : '', marginBottom: '0px' }}>
                                        Dashboard
                                    </h3>
                                    <p style={{ fontFamily: 'Poppins-Light', color: theme === 'light' ? '#FFFFFF' : '#707070', marginTop: '0px', marginBottom: '0px' }}>
                                        Selamat datang, {userInfo?.first_name}  {userInfo?.last_name}
                                    </p>
                                </Col>
                                <Col xs={4} lg={4} className={isMobile === false ? 'text-end my-auto' : 'text-end mt-1'}>
                                    {isMobile === false ? (
                                        <HeaderWeb />
                                    ) : (
                                        <HeaderMobile />
                                    )}
                                </Col>
                            </Row>
                        </Col>
                        <Row>
                            <Col xs={12} lg={6}>
                                <div className='py-4'>
                                    <ChartComponent />
                                </div>
                            </Col>
                            <Col xs={12} lg={6} className='py-4'>
                                <h5 className='text-center py-3' style={{ fontFamily: 'Poppins-Regular', color: theme === 'light' ? '#FFFFFF' : '' }}>
                                    Meeting yang akan datang
                                </h5>
                                <div style={{ overflowY: 'auto', overflowX: 'hidden', height: '350px' }}>
                                    {meetingIncoming.length === 0 ? (
                                        <div className='d-flex justify-content-center align-items-center' style={{ minHeight: '350px' }}>
                                            <p style={{ fontFamily: 'Poppins-Light', color: 'GrayText', fontStyle: 'italic' }}>Tidak ada meeting</p>
                                        </div>
                                    ) : (
                                        <div style={{ overflowY: 'hidden', overflowX: 'hidden' }}>
                                            {dataOngoingMeeting}
                                        </div>
                                    )
                                    }

                                    {/* {dataOngoingMeeting} */}
                                </div>
                            </Col>
                        </Row>
                    </Row>
                    <div className='mx-3 mt-5' style={{
                        backgroundColor: theme === 'light' ? 'rgba(52,58,64, 0.4)' : 'rgba(52, 80, 133, 0.15)',
                        minHeight: '250px',
                        borderRadius: '30px',
                    }}>
                        <Row className="justify-content-center align-items-center" style={{ minHeight: '250px' }}>
                            <Col xs={12} md={12} lg={4} className="my-auto text-center">
                                <h4 className={isMobile ? 'mt-3' : 'pt-3'} style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#D2DC02' : '#10B1AA' }}>
                                    Meetings
                                </h4>
                                <p style={{ fontFamily: 'Poppins-Light', color: '#707070' }}>
                                    Informasi terkait meeting
                                </p>
                            </Col>
                            <Col xs={12} md={12} lg={8} className="d-flex justify-content-center my-3">
                                <Row id='cardMeetinDashboard'>
                                    <Col xs={12} md={6} lg={3} className='my-4'>
                                        <Card
                                            id={theme === 'light' ? 'cardDashboard1-Dark' : 'cardDashboard1-Light'}
                                            style={{ minHeight: '150px', minWidth: isMobile ? '80px' : '150px' }}
                                        >
                                            <div
                                                className='icon-box'
                                                style={{
                                                    background: theme === 'light' ? '#D2DC02' : '#10B1AA'
                                                }}
                                            >
                                                <span>
                                                    <IoCalendar size={25} color={theme === 'light' ? '#121212' : '#FFFFFF'} />
                                                </span>
                                            </div>

                                            {loading ? (
                                                <div
                                                    className='mt-5 d-flex justify-content-center align-items-center'
                                                >
                                                    <Spinner animation='border' style={{ color: theme === 'light' ? '#D2DC02' : '#10B1AA' }} />
                                                </div>
                                            ) : (
                                                <div>
                                                    <p
                                                        className='mt-3 text-center'
                                                        style={{
                                                            fontFamily: 'Poppins-Regular',
                                                            fontSize: '18px',
                                                            marginBottom: '0px',
                                                            color: theme === 'light' ? '#D2DC02' : '#10B1AA'
                                                        }}
                                                    >
                                                        Permintaan
                                                    </p>

                                                    <h2 className='mt-2 text-center' style={{ fontFamily: 'Poppins-SemiBold', color: theme === 'light' ? '#D2DC02' : '#10B1AA' }}>
                                                        {listMeeting?.length || '0'}
                                                    </h2>
                                                </div>
                                            )}
                                        </Card>
                                    </Col>
                                    <Col xs={12} md={6} lg={3} className='my-4'>
                                        <Card
                                            id={theme === 'light' ? 'cardDashboard2-Dark' : 'cardDashboard2-Light'}
                                            style={{ minHeight: '150px', minWidth: isMobile ? '80px' : '150px' }}
                                        >
                                            <div
                                                className='icon-box'
                                                style={{
                                                    background: theme === 'light' ? '#D2DC02' : '#10B1AA'
                                                }}
                                            >
                                                <span >
                                                    <MdLibraryBooks size={25} color={theme === 'light' ? '#121212' : '#FFFFFF'} />
                                                </span>
                                            </div>

                                            {loading ? (
                                                <div
                                                    className='mt-5 d-flex justify-content-center align-items-center'
                                                >
                                                    <Spinner animation='border' style={{ color: theme === 'light' ? '#D2DC02' : '#10B1AA' }} />
                                                </div>
                                            ) : (
                                                <div>
                                                    <p
                                                        className='mt-3 text-center'
                                                        style={{
                                                            fontFamily: 'Poppins-Regular',
                                                            fontSize: '18px',
                                                            marginBottom: '0px',
                                                            color: theme === 'light' ? '#D2DC02' : '#10B1AA'
                                                        }}
                                                    >
                                                        Meeting
                                                    </p>
                                                    <h2 className='mt-2 text-center' style={{ fontFamily: 'Poppins-SemiBold', color: theme === 'light' ? '#D2DC02' : '#10B1AA' }}>
                                                        {meetingToday?.length || '0'}
                                                    </h2>
                                                </div>
                                            )}

                                        </Card>
                                    </Col>
                                    <Col xs={12} md={6} lg={3} className='my-4'>
                                        <Card
                                            id={theme === 'light' ? 'cardDashboard3-Dark' : 'cardDashboard3-Light'}
                                            style={{ minHeight: '150px', minWidth: isMobile ? '80px' : '150px' }}
                                        >
                                            <div
                                                className='icon-box'
                                                style={{
                                                    background: theme === 'light' ? '#D2DC02' : '#10B1AA'
                                                }}
                                            >
                                                <span >
                                                    <MdWorkHistory size={25} color={theme === 'light' ? '#121212' : '#FFFFFF'} />
                                                </span>
                                            </div>

                                            {loading ? (
                                                <div
                                                    className='mt-5 d-flex justify-content-center align-items-center'
                                                >
                                                    <Spinner animation='border' style={{ color: theme === 'light' ? '#D2DC02' : '#10B1AA' }} />
                                                </div>
                                            ) : (
                                                <div>
                                                    <p
                                                        className='mt-3 text-center'
                                                        style={{
                                                            fontFamily: 'Poppins-Regular',
                                                            fontSize: '18px',
                                                            marginBottom: '0px',
                                                            color: theme === 'light' ? '#D2DC02' : '#10B1AA'
                                                        }}
                                                    >
                                                        Riwayat
                                                    </p>
                                                    <h2 className='mt-2 text-center' style={{ fontFamily: 'Poppins-SemiBold', color: theme === 'light' ? '#D2DC02' : '#10B1AA' }}>
                                                        {historyMeeting?.length || '0'}
                                                    </h2>
                                                </div>
                                            )}

                                        </Card>
                                    </Col>
                                    <Col xs={12} md={6} lg={3} className='my-4'>
                                        <Card
                                            id={theme === 'light' ? 'cardDashboard4-Dark' : 'cardDashboard4-Light'}
                                            style={{ minHeight: '150px', minWidth: isMobile ? '80px' : '150px' }}
                                        >
                                            <div
                                                className='icon-box'
                                                style={{
                                                    background: theme === 'light' ? '#D2DC02' : '#10B1AA'
                                                }}
                                            >
                                                <span >
                                                    <FaDoorOpen size={25} color={theme === 'light' ? '#121212' : '#FFFFFF'} />
                                                </span>
                                            </div>

                                            {loading ? (
                                                <div
                                                    className='mt-5 d-flex justify-content-center align-items-center'
                                                >
                                                    <Spinner animation='border' style={{ color: theme === 'light' ? '#D2DC02' : '#10B1AA' }} />
                                                </div>
                                            ) : (
                                                <div>
                                                    <p
                                                        className='mt-3 text-center'
                                                        style={{
                                                            fontFamily: 'Poppins-Regular',
                                                            fontSize: '18px',
                                                            marginBottom: '0px',
                                                            color: theme === 'light' ? '#D2DC02' : '#10B1AA'
                                                        }}
                                                    >
                                                        Ruangan
                                                    </p>
                                                    <h2 className='mt-2 text-center' style={{ fontFamily: 'Poppins-SemiBold', color: theme === 'light' ? '#D2DC02' : '#10B1AA' }}>
                                                        {listRuangan?.length || '0'}
                                                    </h2>
                                                </div>
                                            )}

                                        </Card>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </div>
                    <br />
                </div>
            )}

            <ModalShcedule
                meetingIncoming={meetingIncoming}
                showCalendar={showCalendar}
                setShowCalendar={setShowCalendar}
            />

        </div>
    )
}

export default Dashboard
